import * as actionTypes from '@actions/actionTypes';

/**
 * NOTE (intentional architecture):
 * - Top-level slice in store.js (`state.timezone`), not nested under `app` — many UI consumers
 *   and apolloClient read `state.timezone` directly; moving it would be a high-blast-radius change.
 * - Not redux-persisted — timezone is re-synced from user settings via Header/setTimezone on load.
 * - `autodetected_timezone` uses snake_case to match backend/GraphQL userSettings field names.
 */

export const initialState = {
    timezone: '',
    autodetected_timezone: '',
};

const timezoneReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case actionTypes.SET_TIMEZONE: {
            return {
                ...state,
                timezone: action.data.timezone,
                autodetected_timezone: action.data.autodetected_timezone,
            };
        }

        default:
            return state;
    }
};

export default timezoneReducer;
